import FloatSidebar from 'float-sidebar';

class PressPostPresentation {
  static init(...parameters) {
    return new PressPostPresentation(...parameters);
  }

  constructor(container) {
    const sidebar = container.querySelector('.post > .meta');
    const relative = container.querySelector('.post > .description');

    if (sidebar) {
      this.sidebar = new FloatSidebar({
        sidebar,
        relative,
        topSpacing: 40,
        bottomSpacing: 40,
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-press-post-presentation', PressPostPresentation.init);
}
